import { UPDATE_CONTRIBUTION } from "./Actions";

const initialState = {
  contributionScheme: {
    ratioSelf: 0.5,
    ratioFamily: 0,
  },
};

function updateContributionScheme(state, action) {
  return { ...state, [action.payload.field]: parseInt(action.payload.value || 0, 10) / 100 };
}

export function newCostBreakdownReducer(state = initialState, action) {
  if (action.type === UPDATE_CONTRIBUTION) {
    return { ...state, contributionScheme: updateContributionScheme(state.contributionScheme, action) };
  }

  return state;
}
